import { defineComponent as _defineComponent } from 'vue'
import IconClose from '@/components/icons/IconClose.vue';

const __default__ = {
    inheritAttrs: false,
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'MessageModal',
  setup(__props) {


return { __sfc: true,IconClose }
}

})